import { render, staticRenderFns } from "./MyBookings.vue?vue&type=template&id=1a8e817c&"
import script from "./MyBookings.vue?vue&type=script&lang=js&"
export * from "./MyBookings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports